import React from 'react'
import Card from 'react-bootstrap/Card'
import './basic-cards.css'

function BasicCard({ cardConfig, children }) {
    const { cardTitle, cardHeadingElement } = cardConfig
    return (
        <Card className='basic-listing-card'>
            <Card.Body className='basic-listing-body'>
                {cardTitle && cardHeadingElement && <Card.Title as={cardHeadingElement} className='basic-card-title'>{cardTitle}</Card.Title>}
                {children}
            </Card.Body>
        </Card>
    )
}

export default BasicCard